module.exports = __webpack_public_path__ + "img/9788949123011.91ff4bfd.jpg";